import React, { useLayoutEffect, useState } from "react";
import { ReactComponent as CropXLogo } from "./../../images/powered_by_cropx.svg";
import { ReactComponent as CrropXLogoSmall } from "./../../images/cropx_white_x.svg";
import { ReactComponent as Logo } from "./../../images/dacom-horizontal.svg";
import { useForceUpdateOnHashChange } from "./hooks";
import useLocalStorageState from "use-local-storage-state";
import Icon from "../../shared/icons/Icon";
import { gettext } from "../../shared/utils/legacy";
import cropr from "../../shared/utils/cropr";
import { Dropdown, Modal } from "react-bootstrap";
import ModalHeader from "../../shared/components/ModalHeader";
import CancelButton from "../../shared/buttons/CancelButton";

type AsideProps = {
  children: React.ReactNode;
  showLogo?: boolean;
};

export const AsideContext = React.createContext<any>(null);
const Aside = ({ children, showLogo = true }: AsideProps) => {
  useForceUpdateOnHashChange();
  const navApplicationSwitch = cropr.nav_application_switch || [];
  const [collapsed, setCollapsed] = useLocalStorageState("dfi-sidenav-collapsed", false);
  const [modalData, setModalData] = useState({});
  const openWebsiteModal = (url: string, title: string) => {
    setModalData({ url: url, title: title });
  };
  const onClose = () => {
    setModalData({});
  };
  useLayoutEffect(() => {
    if (collapsed) {
      document.body.classList.add("aside-collapsed");
    } else {
      document.body.classList.remove("aside-collapsed");
    }
  }, [collapsed]);

  return (
    <AsideContext.Provider
      value={{
        collapsed,
      }}
    >
      <aside>
        <div className={`aside-header py-3 px-3 ${showLogo ? "" : "no-brand"}`}>
          <div
            className="navbar-hamburger text-slate-light"
            onClick={() => setCollapsed(!collapsed)}
          >
            <div className="icon">
              <Icon icon={"hamburger"} size={"fa-sm"} />
            </div>
          </div>
          {showLogo && (
            <div className="navbar-brand">
              <Dropdown className="list-none position-static" as={"li"}>
                <Dropdown.Toggle as={"button"} bsPrefix={"btn p-0"}>
                  <Logo className={"logo w-120px"} />
                  <Icon icon={"chevron down"} className={"text-white"} size={"fa-sm"} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="nutrient-dropdown">
                  <ul className={"dropdown-menu-scrollarea"}>
                    <Dropdown.Header>{gettext("Switch to")}</Dropdown.Header>
                    {navApplicationSwitch.switch && navApplicationSwitch.switch.length ? (
                      navApplicationSwitch.switch.map((bbApp, index) => (
                        <Dropdown.Item as={"li"} key={index}>
                          <a href={bbApp.url}>
                            <img src={bbApp.img} width="25" height="25" alt={bbApp.name} />
                            <span className={"pl-3"}>{bbApp.name}</span>
                          </a>
                        </Dropdown.Item>
                      ))
                    ) : (
                      <></>
                    )}
                    {navApplicationSwitch.discover && navApplicationSwitch.discover.length ? (
                      <>
                        <Dropdown.Divider />
                        <Dropdown.Header>{gettext("Discover")}</Dropdown.Header>
                        {navApplicationSwitch.discover.map((discover, index) => (
                          <Dropdown.Item as={"li"} key={"d" + index}>
                            <button
                              className={"btn btn-link"}
                              onClick={() => openWebsiteModal(discover.url, discover.name)}
                            >
                              <img src={discover.img} width="25" height="25" alt={discover.name} />
                              <span className={"pl-3"}>{discover.name}</span>
                            </button>
                          </Dropdown.Item>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
        <div className={`aside-wrapper ${showLogo ? "" : "no-brand"}`}>
          <ul>{children}</ul>
        </div>
        <div className="cropx-logo p-3">
          <CropXLogo className="logo"></CropXLogo>
          <CrropXLogoSmall className="logo-small"></CrropXLogoSmall>
        </div>

        <div className="aside-overlay"></div>
        {Object.keys(modalData).length > 0 && (
          <WebSiteModal modalData={modalData} close={onClose} />
        )}
      </aside>
    </AsideContext.Provider>
  );
};

const WebSiteModal = ({ modalData, close }: any) => {
  return (
    <Modal
      className="modal-md dfi-modal"
      show={true}
      onHide={close}
      data-backdrop={true}
      dialogClassName={"modal-xl"}
    >
      <ModalHeader title={modalData.title} />
      <Modal.Body>
        <iframe
          id="productIframe"
          title="websiteModal"
          data-cookie="marketing"
          src={modalData.url + "?noheader"}
          style={{ width: "100%", height: "calc(100vh - 200px)", border: "0" }}
        ></iframe>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={close}>{gettext("Close")}</CancelButton>
      </Modal.Footer>
    </Modal>
  );
};

export default Aside;
